import type { TweetResponseReferencedTweetTweetAuthor } from './tweetResponseReferencedTweetTweetAuthor';
import type { TweetResponseReferencedTweetTweetBasicInfo } from './tweetResponseReferencedTweetTweetBasicInfo';
import type { TweetResponseReferencedTweetTweetEngagement } from './tweetResponseReferencedTweetTweetEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export type TweetResponseReferencedTweetTweet = {
  /** 트윗 작성자 정보 */
  author?: TweetResponseReferencedTweetTweetAuthor;
  basicInfo?: TweetResponseReferencedTweetTweetBasicInfo;
  engagement?: TweetResponseReferencedTweetTweetEngagement;
};
